module.exports = __webpack_public_path__ + "static/media/exercise.80a68900.svg";